<template>
<div class="header">
    <!-- 折叠按钮 -->
    <!-- <div class="collapse-btn" >
            <router-link to="Forum"><img  src="../../assets/img/logo.png" alt="logo" style="margin-top :10px;width: 50px"></router-link>
        </div>
        <div class="logo"><router-link to="Forum"><span style="color: #fff;">站点首页</span></router-link></div> -->
    <div class="header-user-con">
  <div class="user-name">
    {{ $store.state.uname }}
  </div>
</div>

    <!-- 单独退出按钮固定在右下角 -->
    <button class="fixed-logout-btn" @click="handleCommand('loginout')">
        退出登录
    </button>
    <div class="header-user-con">
        <div class="user-avator">
            <img :src="$store.state.faceimg" />
        </div>
        <el-dropdown class="user-name" trigger="click">
            <span class="el-dropdown-link">
                {{$store.state.uname}}
                <i class="el-icon-caret-bottom"></i>
            </span>
            <template #dropdown>
                <el-dropdown-menu>
                    <el-dropdown-item>个人中心</el-dropdown-item>
                </el-dropdown-menu>
            </template>
        </el-dropdown>
    </div>

    <!-- 单独退出按钮固定在右下角 -->
    <button class="fixed-logout-btn" @click="handleCommand('loginout')">
        退出登录
    </button>
</div>
</template>

<script>
import {
    logout,
    messageSocketUrl
} from "../../api/common";
import PubSub from "pubsub-js";

export default {
    data() {
        return {
            isCollapse: true,

            lander: {},
        };
    },
    methods: {

        handleCommand(command) {
            if (command == "loginout") {
                logout();
            }
        },

        getMessageSocket() {

            let that = this;
            if ("WebSocket" in window) {
                that.ws = new WebSocket(messageSocketUrl + this.lander.uid);
                that.$messageSocket.setWs(that.ws);
                that.$messageSocket.ws.onopen = function () {};

                that.$messageSocket.ws.onmessage = function (msg) {
                    console.log(msg.data)
                    let m = JSON.parse(msg.data);
                    that.$notify({
                        title: '你收到一条消息',
                        message: m.msg,
                        duration: 2000
                    });
                    //消息通知上面小红点出现
                    PubSub.publish('changeMyNotReadMessageNum', "1");
                };

                that.ws.onclose = function () {
                    // 关闭 websocket
                    console.log("连接已关闭...");
                    setTimeout(() => {
                        that.getMessageSocket();
                    }, 2000);
                };
            } else {
                this.$message.error("您的浏览器不支持 WebSocket!")
                // 浏览器不支持 WebSocket
                // console.log("您的浏览器不支持 WebSocket!");
            }
        },

    },
    mounted() {
        this.lander = JSON.parse(this.$store.state.logininfo);
        // this.getMessageSocket();

    }
};
</script>

<style scoped>
.header {
    position: relative;
    box-sizing: border-box;
    width: 200px;
    height: 70px;
    font-size: 22px;
    color: #fff;
}

.collapse-btn {
    float: left;
    padding: 0px 0px;
    cursor: pointer;
    line-height: 50px;
    width: 198px;
}

.header .logo {
    float: left;
    width: 200px;
    line-height: 70px;
}

.header-right {
    float: right;
    padding-right: 50px;
}

.header-user-con {
    display: flex;
    height: 80px;
    align-items: center;
}

.btn-fullscreen {
    transform: rotate(45deg);
    margin-right: 5px;
    font-size: 24px;
}

.btn-bell,
.btn-fullscreen {
    position: relative;
    width: 30px;
    height: 30px;
    text-align: center;
    border-radius: 15px;
    cursor: pointer;
}

.btn-bell-badge {
    position: absolute;
    right: 0;
    top: -2px;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background: #f56c6c;
    color: #fff;
}

.btn-bell .el-icon-bell {
    color: #fff;
}

.user-name {
    margin-left: 10px;
}

.user-avator {
    margin-left: 20px;
}

.user-avator img {
    display: block;
    width: 40px;
    height: 40px;
    border-radius: 50%;
}

.el-dropdown-link {
    color: #fff;
    cursor: pointer;
}

.el-dropdown-menu__item {
    text-align: center;
}

.fixed-logout-btn {
    position: fixed;
    left: 20px;
    bottom: 20px;
    padding: 8px 15px;
    background-color: #F56C6C;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    z-index: 1000;
}

.fixed-logout-btn:hover {
    background-color: #ff7875;
}
.header-user-con {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 16px;
    background: linear-gradient(135deg, #6e8efb, #a777e3); /* 渐变背景 */
    border-radius: 20px; /* 圆角 */
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* 阴影 */
  }
  
  .user-name {
    font-size: 18px;
    font-weight: bold;
    color: white; /* 白色文字 */
    font-family: 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif; /* 更美观的字体 */
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2); /* 文字阴影 */
  }
</style>
<template>
<div class="header">
    <!-- 折叠按钮 -->
    <!-- <div class="collapse-btn" >
            <router-link to="Forum"><img  src="../../assets/img/logo.png" alt="logo" style="margin-top :10px;width: 50px"></router-link>
        </div>
        <div class="logo"><router-link to="Forum"><span style="color: #fff;">站点首页</span></router-link></div> -->
    <div class="header-user-con">
  <div class="user-name">
    {{ $store.state.uname }}
  </div>
</div>

    <!-- 单独退出按钮固定在右下角 -->
    <button class="fixed-logout-btn" @click="handleCommand('loginout')">
        退出登录
    </button>
    <div class="header-user-con">
        <div class="user-avator">
            <img :src="$store.state.faceimg" />
        </div>
        <el-dropdown class="user-name" trigger="click">
            <span class="el-dropdown-link">
                {{$store.state.uname}}
                <i class="el-icon-caret-bottom"></i>
            </span>
            <template #dropdown>
                <el-dropdown-menu>
                    <el-dropdown-item>个人中心</el-dropdown-item>
                </el-dropdown-menu>
            </template>
        </el-dropdown>
    </div>

    <!-- 单独退出按钮固定在右下角 -->
    <button class="fixed-logout-btn" @click="handleCommand('loginout')">
        退出登录
    </button>
</div>
</template>

<script>
import {
    logout,
    messageSocketUrl
} from "../../api/common";
import PubSub from "pubsub-js";

export default {
    data() {
        return {
            isCollapse: true,

            lander: {},
        };
    },
    methods: {

        handleCommand(command) {
            if (command == "loginout") {
                logout();
            }
        },

        getMessageSocket() {

            let that = this;
            if ("WebSocket" in window) {
                that.ws = new WebSocket(messageSocketUrl + this.lander.uid);
                that.$messageSocket.setWs(that.ws);
                that.$messageSocket.ws.onopen = function () {};

                that.$messageSocket.ws.onmessage = function (msg) {
                    console.log(msg.data)
                    let m = JSON.parse(msg.data);
                    that.$notify({
                        title: '你收到一条消息',
                        message: m.msg,
                        duration: 2000
                    });
                    //消息通知上面小红点出现
                    PubSub.publish('changeMyNotReadMessageNum', "1");
                };

                that.ws.onclose = function () {
                    // 关闭 websocket
                    console.log("连接已关闭...");
                    setTimeout(() => {
                        that.getMessageSocket();
                    }, 2000);
                };
            } else {
                this.$message.error("您的浏览器不支持 WebSocket!")
                // 浏览器不支持 WebSocket
                // console.log("您的浏览器不支持 WebSocket!");
            }
        },

    },
    mounted() {
        this.lander = JSON.parse(this.$store.state.logininfo);
        // this.getMessageSocket();

    }
};
</script>

<style scoped>
.header {
    position: relative;
    box-sizing: border-box;
    width: 200px;
    height: 70px;
    font-size: 22px;
    color: #fff;
}

.collapse-btn {
    float: left;
    padding: 0px 0px;
    cursor: pointer;
    line-height: 50px;
    width: 198px;
}

.header .logo {
    float: left;
    width: 200px;
    line-height: 70px;
}

.header-right {
    float: right;
    padding-right: 50px;
}

.header-user-con {
    display: flex;
    height: 80px;
    align-items: center;
}

.btn-fullscreen {
    transform: rotate(45deg);
    margin-right: 5px;
    font-size: 24px;
}

.btn-bell,
.btn-fullscreen {
    position: relative;
    width: 30px;
    height: 30px;
    text-align: center;
    border-radius: 15px;
    cursor: pointer;
}

.btn-bell-badge {
    position: absolute;
    right: 0;
    top: -2px;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background: #f56c6c;
    color: #fff;
}

.btn-bell .el-icon-bell {
    color: #fff;
}

.user-name {
    margin-left: 10px;
}

.user-avator {
    margin-left: 20px;
}

.user-avator img {
    display: block;
    width: 40px;
    height: 40px;
    border-radius: 50%;
}

.el-dropdown-link {
    color: #fff;
    cursor: pointer;
}

.el-dropdown-menu__item {
    text-align: center;
}

.fixed-logout-btn {
    position: fixed;
    left: 20px;
    bottom: 20px;
    padding: 8px 15px;
    background-color: #F56C6C;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    z-index: 1000;
}

.fixed-logout-btn:hover {
    background-color: #ff7875;
}
.header-user-con {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 16px;
    background: linear-gradient(135deg, #6e8efb, #a777e3); /* 渐变背景 */
    border-radius: 20px; /* 圆角 */
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* 阴影 */
  }
  
  .user-name {
    font-size: 18px;
    font-weight: bold;
    color: white; /* 白色文字 */
    font-family: 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif; /* 更美观的字体 */
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2); /* 文字阴影 */
  }
</style>
